customElements.define(
  'product-size-guide',
  class ProductSizeGuide extends ModalDialog {
    constructor() {
      super();
      this.countrySelector = this.querySelector('[data-country-selector]');
      this.sizeTables = this.querySelectorAll('[data-size-table]');
      this.sizeTables.forEach((table, index) => {
        if (index !== 0) {
          table.style.display = 'none';
        }
      });

      this.addEventListener('click', (event) => {
        if (event.target.classList.contains('custom-drawer')) this.hide();
      });
    }

    connectedCallback() {
      this.countrySelector.addEventListener('change', this.onChange.bind(this));
    }

    disconnectedCallback() {
      this.countrySelector.removeEventListener('change', this.onChange.bind(this));
    }

    onChange() {
      const selectedCountry = this.countrySelector.value;
      this.sizeTables.forEach((sizeTable) => {
        if (sizeTable.id === selectedCountry) {
          sizeTable.style.display = 'block';
        } else {
          sizeTable.style.display = 'none';
        }
      });
    }
  }
);